/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Redirect, Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import awsmobile from './../aws-exports';
import {Auth} from 'aws-amplify';

const logo = require('../components/images/hipkar-logo-text.png');

const styles = theme => ({
  container: {
    display: 'flex',
    width:'100%',
    height:'100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  hipkarLogo: {
    maxWidth: '50%',
  },
  textFieldContainer: {
    width: 400,
    height: 600,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'flex',
    paddingTop: '2em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 400,
  },
  textField: {
    marginLeft: theme.spacing.unit*3,
    marginRight: theme.spacing.unit*3,
    width: 346,
  },
  validationLabels: {
    marginLeft: theme.spacing.unit*3,
  },
  buttonsContainer: {
    display: 'flex',
    paddingTop: '2em',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: 400,
  },
});

class Register extends Component {

    state = {
        username: '',
        password: '',
        passwordMatch: '',
        email: '',
        phone: '',
        code: '',
        enterAuth: false,
        authSuccess: false,
        invalidUserNameMessage: '',
        invalidPasswordMessage: '',
        invalidEmailMessage: '',
        invalidPhoneMessage: '',
        invalidCodeMessage: '',
        invalidFormDataMessage: '',
        enableResend: false
    };

    handleVerificationCodeChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        this.setState(() => {
            return {
                code: value,
                invalidCodeMessage: ''
            }
        });
    }

      handleSubmit = async (e) => {
          e.preventDefault();

          const username = this.state.username.trim();
          const password = this.state.password.trim();
          const passwordMatch = this.state.passwordMatch.trim();

          const email = this.state.email.trim();

          var phone = this.state.phone.trim();


          const validUserNameMessage = !this.state.invalidUserNameMessage;
          const validPasswordMessage = !this.state.invalidPasswordMessage;
          const validEmailMessage = !this.state.invalidEmailMessage;
          const validPhoneMessage = !this.state.invalidPhoneMessage;
          const validEmailPattern = this.checkEmailPattern(this.state.email);
          const validPhonePattern = this.checkPhonePattern(this.state.phone);
          const validPassword = this.checkPassword(this.state.password);
          const validPasswordMatch = this.checkPasswordMatch(password, passwordMatch);
          const validUsernameMatch = this.checkUsernameMatch(this.state.username);

          const checkRegistrationForm = validUserNameMessage && validPasswordMessage
                        && validEmailMessage  && validPhoneMessage
                        && validEmailPattern && validPhonePattern
                        && validPasswordMatch && validUsernameMatch && validPassword;

         if (!checkRegistrationForm) {
             alert("Invalid registration details.")
             return;
         }

         phone = this.cleanPhoneNumber(phone);

         Auth.signUp(username,password,email,phone)
             .then(
                this.setState(() => {
                    return {
                        enterAuth: true
                    }
                })
             )
             .catch( err =>
                console.log(err)
             )
    }



    handleSubmitVerification = async (e) => {
        e.preventDefault();
        const verificationCode = this.state.code;
        const username = this.state.username;
        Auth.confirmSignUp(username, verificationCode)
            .then(
                this.setState(() => {
                    return {
                        authSuccess: true
                    }
                })
            )
            .catch(
                this.setState(() => {
                    return {
                        invalidCodeMessage: 'Invalid Verification Code'
                    }
                })
            )
    }

    resendVerificationCode = async (e) => {
        e.preventDefault();
        const username = this.state.username;
        Auth.resendSignUp(username)
            .then(
                this.setState(() => {
                    return {
                        enableResend: false,
                    }
                })
            )
            .catch(
                err => console.log(err)
            )
    }

    checkUsernameMatch = (username) => {
        return username && username.length > 1;
    }

    checkPassword = (password) => {
      console.log('password length: ' + password.length);
      if (password.length < 6) {
        this.setState(() => {
          return {invalidPasswordMessage: 'Your password needs a minimum of six characters'}
        })
      } else if (password.search(/[a-z]/) < 0) {
        this.setState(() => {
          return {invalidPasswordMessage: 'Your password needs an lower case letter'}
        })
      } else if (password.search(/[A-Z]/) < 0) {
        this.setState(() => {
          return {invalidPasswordMessage: 'Your password needs an upper case letter'}
        })
      } else  if (password.search(/[0-9]/) < 0) {
        this.setState(() => {
          return {invalidPasswordMessage: 'Your password needs a number'}
        })
      } else {
        return true;
      }
    }

    checkPasswordMatch = (password, passwordMatch) => {
        return password === passwordMatch;
    }

    checkEmailPattern = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    checkPhonePattern = (phone) => {
        //return /^\+?[1-9]\d{1,14}$/.test(phone);
        //return phone.match(/\d/g).length===10;
        var phoneno = /^\+?(1?)?[-. ]?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if(phone.match(phoneno)) {
          return true;
        } else {
          this.setState(() => {
            return {invalidPhoneMessage: 'Invalid phone number. Valid example: +12128675309'}
          })
          return false;
        }
    }

    cleanPhoneNumber = (phone) => {
      var phoneno = /^(\+1)[-. ]?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if(!phone.match(phoneno)) {
        phone = '+1' + phone; //add the +1
      }
      phone = phone.replace(/[-. ]/g, '')
      console.log('phone: ' + phone);
      return phone;
    }

    countDownResendVerificationCode = () => {
        let counter = 10;
        var seconds = setInterval(() => {
            if (counter == 0) {
                clearInterval(seconds);
                this.setState(() => {
                    return {
                        enableResend: true
                    }
                });
            }
            counter--;
        }, 1000);
    }

    handlePasswordMatchChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        const message = this.checkPasswordMatch(value, this.state.password) ? '' : 'Password does not match';
        this.setState(() => {
            return {
                passwordMatch: value,
                invalidPasswordMessage: message,
                invalidFormDataMessage: ''
            }
        });
    }

    render() {
        const { username,
                password,
                passwordMatch,
                email,
                phone,
                invalidUserNameMessage,
                invalidPasswordMessage,
                invalidEmailMessage,
                invalidPhoneMessage,
                enableResend,
                invalidCodeMessage,
                invalidFormDataMessage } = this.state;

        const { classes } = this.props;

            return (
                <CSSTransitionGroup
                transitionName="sample-app"
                transitionEnterTimeout={500}
                transitionAppearTimeout={500}
                transitionLeaveTimeout={300}
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}>
                <div className={classes.container}>
                    {!this.state.enterAuth && !this.state.authSuccess && (
                        <div>
                            <Paper className={classes.textFieldContainer} elevation={0}>
                              <div className={classes.logoContainer}>
                                <img src={logo} className={classes.hipkarLogo}  alt="hipkar - get the best deal on a car lease" />
                              </div>
                              <TextField
                                id="username"
                                label="Username"
                                className={classes.textField}
                                value={this.state.username}
                                onChange = {(event) => this.setState({username:event.target.value, invalidUserNameMessage: '', invalidFormDataMessage: ''})}
                                margin="normal"
                              />
                            { invalidUserNameMessage && <Typography className={classes.validationLabels} variant="body1" color="error" gutterBottom>{ invalidUserNameMessage }</Typography> }
                              { username && !this.checkUsernameMatch(username) && <Typography className={classes.validationLabels} variant="body1" color="error" gutterBottom>Invalid username, must conatin atleast 1 character</Typography> }

                              <TextField
                                id="email"
                                label="Email"
                                className={classes.textField}
                                value={this.state.email}
                                onChange = {(event) => this.setState({email:event.target.value, invalidEmailMessage: '', invalidFormDataMessage: ''})}
                                margin="normal"
                              />
                            { invalidEmailMessage && <Typography className={classes.validationLabels} variant="body1" color="error" gutterBottom>{ invalidEmailMessage }</Typography> }
                              { email && !this.checkEmailPattern(email) && <Typography className={classes.validationLabels} variant="body1" color="error" gutterBottom>Invalid email format</Typography> }

                              <TextField
                                id="password-input"
                                label="Password"
                                className={classes.textField}
                                onChange = {(event) => this.setState({password:event.target.value, invalidPasswordMessage: '', invalidFormDataMessage: ''})}
                                type="password"
                                margin="normal"
                              />

                              <TextField
                                id="password-confirm"
                                label="Re-enter Password"
                                className={classes.textField}
                                type="password"
                                margin="normal"
                                onChange={this.handlePasswordMatchChange}
                              />
                              { invalidPasswordMessage && <Typography className={classes.validationLabels} variant="body1" color="error" gutterBottom>{ invalidPasswordMessage }</Typography> }

                              <TextField
                                id="phone"
                                label="Phone"
                                className={classes.textField}
                                onChange = {(event) => this.setState({phone:event.target.value, invalidPhoneMessage: '', invalidFormDataMessage: ''})}
                                margin="normal"
                              />
                            { invalidPhoneMessage && <Typography className={classes.validationLabels} color="error" variant="body1" gutterBottom>{ invalidPhoneMessage }</Typography> }


                              <div className={classes.buttonsContainer}>
                                { invalidFormDataMessage && <Typography className={classes.validationLabels} variant="body1" gutterBottom>{ invalidFormDataMessage }</Typography> }
                                <Button variant="raised" component={Link} to={'/'}  style={{marginRight: 1 + 'em'}}>Cancel</Button>
                                <Button variant="raised" color="primary" style={{marginRight: 2 + 'em'}} onClick={this.handleSubmit}>Register</Button>
                              </div>

                              <div className={classes.buttonsContainer}>
                                <Typography style={{marginRight: 2 + 'em'}} variant="subheading" gutterBottom>
                                  Already registered? <Link to="/login"> Login</Link>
                                </Typography>
                              </div>
                            </Paper>
                        </div>
                    )}
                    {this.state.enterAuth && !this.state.authSuccess && (
                    <Paper className={classes.textFieldContainer}>
                          <TextField
                            id="phone"
                            label="We emailed you a code. Please enter it here."
                            className={classes.textField}
                            onChange = {(event) => this.setState({code:event.target.value, invalidCodeMessage: ''})}
                            margin="normal"
                          />
                         { invalidCodeMessage && <Typography className={classes.validationLabels} variant="body1" gutterBottom>Invalid verfication code</Typography> }

                        <div className={classes.buttonsContainer}>
                            <Button color="primary" onClick={ this.handleSubmitVerification }>Confirm</Button>
                            { !enableResend && <Button onClick={this.countDownResendVerificationCode()}>Waiting to resend</Button> }
                            { enableResend && <Button onClick={this.resendVerificationCode}>Resend it!</Button> }
                        </div>
                    </Paper>
                    )}
                    {this.state.authSuccess && (<Redirect to='/Auth/login' />)}
                </div>
                </CSSTransitionGroup>
            )
    }
}

Register.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Register);



// WEBPACK FOOTER //
// ./src/Auth/Register.jsx